import { render } from "./OfferReceiverForm.vue?vue&type=template&id=1fd77da5"
import script from "./OfferReceiverForm.vue?vue&type=script&lang=js"
export * from "./OfferReceiverForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__